import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { FDBodyText } from '@facet-wealth/design';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.facet.accentBlue20,
    borderRadius: theme.radius.md,
    padding: theme.spacing(2, 3),
  },
  blurbList: {
    margin: theme.spacing(1, 0, 0),
    paddingInlineStart: '12px',
    fontSize: '1rem',
  },
  blurbListItem: {
    fontSize: '1rem',
  },
});

const WelcomeBlurb = ({
  className,
  classes,
  title,
  bullets,
}) => {
  const hasOnlyOneBullet = bullets.length === 1;
  return (
    <Box className={classNames(classes.root, className)}>
      <FDBodyText color={'textSecondary'} value={title} />
      {hasOnlyOneBullet ? (
        bullets.map(({ text }) => {
          return (
            <Typography
              className={classes.blurbListItem}
              key={text}
              variant="body1"
              color={'primaryGray'}
              weight={'medium'}
            >
              {text}
            </Typography>
          );
        })
      ) : (
        <ul className={classes.blurbList}>
          {bullets.map(({ text }) => {
            return (
              <Typography
                className={classes.blurbListItem}
                key={text}
                variant="body1"
                color={'primaryGray'}
                weight={'medium'}
                component={'li'}
              >
                {text}
              </Typography>
            );
          })}
        </ul>
      )}
    </Box>
  );
};

WelcomeBlurb.defaultProps = {
  className: '',
};

WelcomeBlurb.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  bullets: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withStyles(styles)(WelcomeBlurb);
